import { Wire } from '@ec-workspace/ec-library';

export class UnknownWire extends Wire {
  get type() {
    return 'Wire';
  }
}
